import { createContext, useState } from "react"

import { isServer } from "@p-ban/common/src/utils/CommonUtils"

import type { ManufactureCourse } from "../constant/manufactureCourse"
import MANUFACTURE_COURSE from "../constant/manufactureCourse"
import type { MountCourse } from "../constant/mountCourse"
import MOUNT_COURSE from "../constant/mountCourse"
import fillRestWithInitialValues from "../service/fillRestWithInitialValues"
import type { Touched } from "../types"
import type { EstimateMeta } from "../types/params"
import useRestoreValues from "./service/hooks/useRestoreValues"

const initEstimateMeta = (): EstimateMeta => {
  const sessionStorageKey = "EstimateMeta"
  const initialMeta: EstimateMeta = {
    viaSite: "",
    subject: "",
    designSparkQuoteId: "",
    orgSpecSummaryOrderNo: "",
  }

  if (isServer) {
    return initialMeta
  }

  let { search } = window.location
  try {
    if (window.location.hash === "#bomParsingFlg") {
      search = sessionStorage.getItem(sessionStorageKey) ?? search
    }
    sessionStorage.setItem(sessionStorageKey, search)
  } catch {}

  const params = new URLSearchParams(search)

  const meta = { ...initialMeta }
  ;(Object.keys(initialMeta) as (keyof EstimateMeta)[]).forEach((key) => {
    meta[key] = params.get(key) ?? ""
  })

  return meta
}

const use1ClickEstimate = () => {
  const [valuesAndTouched, setValuesAndTouched] = useState(() => ({
    values: fillRestWithInitialValues({}),
    touched: {} as Touched,
  }))
  const [bomSnapshotId, setBomSnapshotId] = useState<string | null>(null)
  const [deliveryZeroFlg, setDeliveryZeroFlg] = useState<boolean>(false)
  const [mountQuickFlg, setMountQuickFlg] = useState<boolean>(false)
  const [metalMaskStockPartName, setMetalMaskStockPartName] = useState<string | null>(null)
  const [boardStockPartName, setBoardStockPartName] = useState<string | null>(null)
  const [meta] = useState(initEstimateMeta)
  const [partsListMapkey, setPartsListMapkey] = useState<string>("")
  useRestoreValues(setValuesAndTouched, setBomSnapshotId, setDeliveryZeroFlg, setMountQuickFlg, setMetalMaskStockPartName, setBoardStockPartName)

  const [manufactureCourse, setManufactureCourse] = useState<ManufactureCourse>(MANUFACTURE_COURSE.normal)
  const [MountCourse, setManufactureMount] = useState<MountCourse>(MOUNT_COURSE.mount)

  return {
    valuesAndTouched,
    setValuesAndTouched,
    manufactureCourse,
    setManufactureCourse,
    MountCourse,
    setManufactureMount,
    meta,
    bomSnapshotId,
    deliveryZeroFlg,
    setDeliveryZeroFlg,
    mountQuickFlg,
    setMountQuickFlg,
    partsListMapkey,
    setPartsListMapkey,
    metalMaskStockPartName,
    boardStockPartName,
  }
}

const OneClickEstimateContext = createContext<ReturnType<typeof use1ClickEstimate>>(null as any)
export const OneClickEstimateProvider = ({ children }: { children: React.ReactNode }) => {
  const value = use1ClickEstimate()
  return <OneClickEstimateContext.Provider value={value}>{children}</OneClickEstimateContext.Provider>
}

export default OneClickEstimateContext
